const LOADING = 'LOADING';
const OPEN = 'OPEN';
const DATE = 'DATE';

const types = {
    LOADING,
    OPEN,
    DATE,
};

export default types;